
import { useState, useEffect } from "react"; 
import { Link } from 'react-router-dom'
import LazyLoad from "react-lazyload";
const Faculties = () => {
    const [section, setSection] = useState("Senior"); 
    useEffect(() => {
      
    })
    return (
        <>
            <div className="breadcrumb">
                <h2>Faculties with Sections</h2>
                <ul>
                    <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
                    <li>|</li>
                    <li>School</li>
          <li>|</li>
                    <li>Faculties with Sections</li>
                </ul>
            </div>
            <div className="inner_page faculty_inner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="d-flex">
                                <button className={section === "Senior" ? 'active': ''} onClick={() => setSection("Senior")}>SENIOR SECTION</button>
                                <button className={section === "Primary" ? 'active': ''}  onClick={() => setSection("Primary")}>PRIMARY SECTION</button>
                                <button className={section === "kindergarten" ? 'active': ''}  onClick={() => setSection("kindergarten")}>KINDERGARTEN</button>
                            </div>
                        </div>
                    </div>

                    {section === "Senior" && (
                        <div class="row g-3">
                            <div className="col-md-12">
                                <h3>SENIOR SECTION</h3>
                                </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                              <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-1.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MR. SANDEEP BAWA</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-2.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MRS. KIRAN</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-3.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MR. YOUSEF JOHN</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-4.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MRS. RUBY SINGH</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-5.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MRS. RENU VERMA</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-6.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MRS. RADHIKA</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-7.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MRS. NEETU</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-8.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MRS. GEETA KHOSLA</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-9.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MRS. ANJU DUGGAL</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-10.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MRS. RINKY KHORANA</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-11.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MR. RONY FRANCIS</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-12.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MR. NAVTEJ SINGH</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-13.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MR. MANDEEP</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-14.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MRS. KAJAL</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-15.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MS. SONU WADIA</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-16.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MRS. NEELAM</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-17.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MR. KANWALJIT SINGH</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-18.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MRS. RAMA SHARMA</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-19.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MRS. SONIA SETH</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-20.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MRS. PARVEEN MISHRA</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-21.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MRS. JULIET</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-22.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MRS. PUNEET BABAR</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                          <div class="faculty-member">
                            <div class="faculty-member-img">
                             <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/sr-faculty-23.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                              <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                                <h4>MS. ANUDEEP KAUR</h4>
                                <h5><span>SENIOR SECTION</span></h5>
                              </div>
                            </div>  
                          </div>
                        </div>
                      </div>
                    )

                    }
                    {section === "Primary" && (
                      <div class="row g-3">
                        <div className="col-md-12"><h3>PRIMARY SECTION</h3></div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-1.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MR. KLEMENT DAVID</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-2.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. SHAMA</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-3.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MS. GAGANDEEP KAUR</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-4.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. JOSEPHINE MATHIAS</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-5.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. RIMPI SHARMA</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-6.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. KOMAL DHAWAN</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-7.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. GURJIT KAUR</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-8.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MS. LILLY DANIEL</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-9.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MR. PUNEET SAINI</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-10.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. SHALLU</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-11.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. RITA BHATTI</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-12.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. AKWINDER KAUR</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-13.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. RACHNA AGARWAL</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-14.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. RAMANJIT KARU</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-15.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. MONIKA SHARMA</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-16.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. RAJINI</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-17.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. DIVYA V. NAIR</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-18.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. POONAM SHARMA</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-19.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. SATINDER KAUR</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-20.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. ARCHANA PURI</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-21.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. SIMERJIT KARU</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-22.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. MANJU SHARMA</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-23.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. ANJUM SIDHU</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-24.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. NAMRATA SHARMA</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-25.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. NEHA SHARMA</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-26.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. ANCHNA BEDI</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-27.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. KAMALJIT WALTER</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-28.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. ELIZABETH</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-29.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. ANITA RAMPAL</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-30.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. DINA LAZAR</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-31.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. SATINDER KAUR</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                      <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                        <div class="faculty-member">
                          <div class="faculty-member-img">
                           <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/pri-faculty-32.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                            <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                              <h4>MRS. SURINDER KAUR</h4>
                              <h5><span>PRIMARY SECTION</span></h5>
                            </div>
                          </div>  
                        </div>
                      </div>
                    </div>
                    )

                    }
                    {section === "kindergarten" && (
                       <div class="row g-3">
                        
                        <div className="col-md-12"><h3>KINDERGARTEN SECTION</h3></div>
                       <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                         <div class="faculty-member">
                           <div class="faculty-member-img">
                            <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/kg-faculty-1.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                             <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                               <h4>MRS. RASHIMR SHARMA</h4>
                               <h5><span>KINDERGARTEN</span></h5>
                             </div>
                           </div>  
                         </div>
                       </div>
                       <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                         <div class="faculty-member">
                           <div class="faculty-member-img">
                            <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/kg-faculty-2.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                             <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                               <h4>MRS. MADHURI SHARMA</h4>
                               <h5><span>KINDERGARTEN</span></h5>
                             </div>
                           </div>  
                         </div>
                       </div>
                       <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                         <div class="faculty-member">
                           <div class="faculty-member-img">
                            <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/kg-faculty-3.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                             <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                               <h4>MRS. RAMANDEEP KAUR</h4>
                               <h5><span>KINDERGARTEN</span></h5>
                             </div>
                           </div>  
                         </div>
                       </div>
                       <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                         <div class="faculty-member">
                           <div class="faculty-member-img">
                            <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/kg-faculty-4.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                             <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                               <h4>MRS. MEENAKSHI SHARMA</h4>
                               <h5><span>KINDERGARTEN</span></h5>
                             </div>
                           </div>  
                         </div>
                       </div>
                       <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                         <div class="faculty-member">
                           <div class="faculty-member-img">
                            <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/kg-faculty-5.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                             <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                               <h4>MRS. SONIKA BAJAJ</h4>
                               <h5><span>KINDERGARTEN</span></h5>
                             </div>
                           </div>  
                         </div>
                       </div>
                       <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                         <div class="faculty-member">
                           <div class="faculty-member-img">
                            <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/kg-faculty-6.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                             <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                               <h4>MRS. MONIKA</h4>
                               <h5><span>KINDERGARTEN</span></h5>
                             </div>
                           </div>  
                         </div>
                       </div>
                       <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                         <div class="faculty-member">
                           <div class="faculty-member-img">
                            <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/kg-faculty-7.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                             <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                               <h4>MRS. SHIVANI</h4>
                               <h5><span>KINDERGARTEN</span></h5>
                             </div>
                           </div>  
                         </div>
                       </div>
                       <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                         <div class="faculty-member">
                           <div class="faculty-member-img">
                            <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/kg-faculty-8.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                             <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                               <h4>MRS. SONIA NAYYAR</h4>
                               <h5><span>KINDERGARTEN</span></h5>
                             </div>
                           </div>  
                         </div>
                       </div>
                       <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                         <div class="faculty-member">
                           <div class="faculty-member-img">
                            <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/kg-faculty-9.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                             <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                               <h4>MRS. VIJAY LAKSHAMI</h4>
                               <h5><span>KINDERGARTEN</span></h5>
                             </div>
                           </div>  
                         </div>
                       </div>
                       <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                         <div class="faculty-member">
                           <div class="faculty-member-img">
                            <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/kg-faculty-10.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                             <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                               <h4>MRS. ISHA UPPAL</h4>
                               <h5><span>KINDERGARTEN</span></h5>
                             </div>
                           </div>  
                         </div>
                       </div>
                       <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                         <div class="faculty-member">
                           <div class="faculty-member-img">
                            <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/kg-faculty-11.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                             <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                               <h4>MRS. NIDHI PAUL</h4>
                               <h5><span>KINDERGARTEN</span></h5>
                             </div>
                           </div>  
                         </div>
                       </div>
                       <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                         <div class="faculty-member">
                           <div class="faculty-member-img">
                            <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/faculty/kg-faculty-12.jpg" class="img-fluid" alt="St. Francis School, Amritsar" /></LazyLoad>
                             <div class="faculty-member-details d-flex flex-column faculty-member-overlay">
                               <h4>MRS. NEELAM</h4>
                               <h5><span>KINDERGARTEN</span></h5>
                             </div>
                           </div>  
                         </div>
                       </div>
                     </div>
                    )

                    }


                </div>
            </div>
        </>
    )
}

export default Faculties
